var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAutostartTurnedOn = function SvgAutostartTurnedOn(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3585",
    width: 44,
    height: 44,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1008.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3886",
    transform: "translate(-174.3 989.64)scale(.98047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3881",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3825",
    d: "M187.09 45.476a2.524 2.524 0 1 1-5.048 0 2.524 2.524 0 0 1 5.048 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3827",
    d: "M205.82 45.476a2.524 2.524 0 1 1-5.048 0 2.524 2.524 0 0 1 5.048 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3829",
    d: "M197.78 35.062a36 36 0 0 0-1.781.031c-.732.03-1.36.072-1.813.156-.345.123-4.969 3.375-4.969 3.375s-8.344 1.178-10.594 2.532l.22 2.28h-.626c-.446.145-.09.694.125 1.157h.719l.813.75v.344l1.156.031s.229-3.5 3.53-3.5c3.303 0 3.313 4 3.313 4h11.97s-.162-4.031 3.437-4.031 3.406 4.094 3.406 4.094c.989 0 1.604-.406 1.875-.875l.031-.594h.594c.2-.515.476-.985.156-1.344h-.468V40.25c-.53-.63-4.299-3.925-5.907-4.75-1.266-.272-3.314-.42-5.187-.437zm-2.312 1.281a.5.5 0 0 1 .156 0h2.125l-.531 3.156h-4.657c-.416-.008-.62-.663-.281-.906l3.063-2.156a.5.5 0 0 1 .125-.094m3.562 0h2.313a.5.5 0 0 1 .312.094l2.625 2.187c.298.263.085.861-.312.875h-5.438z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3834",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M210.19 44.758c.531.747.816.875 1.547.89a1.61 1.61 0 0 0 1.344-.656c.411.61 1.115 1 1.906 1a2.28 2.28 0 0 0 2.281-2.093 2.9 2.9 0 0 0 1.656.5c1.656 0 3-1.345 3-3s-1.344-3-3-3h0c-1.655 0-3 1.344-3 3 0 .076.026.143.032.218a2.3 2.3 0 0 0-.97-.218c-.958 0-1.751.601-2.093 1.437-.301-.3-.697-.52-1.156-.5-.7.031-.875.378-1.422.875"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAutostartTurnedOn);
export default ForwardRef;